import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './HistoryRadio.css';

const HistoryRadio = ({ serverId }) => {
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://radio.amgroupmkt.com:1030/api/v2/history/?limit=10&offset=0&server=${serverId}`);
        const updatedResults = response.data.results.map(item => ({
          ...item,
          img_url: item.img_url || "https://radio.amgroupmkt.com:1030/media/widgets/am_radio_64x64.png"
        }));
        setHistoryData(updatedResults);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 15000);
    return () => clearInterval(intervalId);
  }, [serverId]);

  return (
    <div className="history-container">
      <h3 className="history-title">Historial de Reproducción</h3>
      <div className="history-list">
        {historyData.map((item, index) => (
          <div key={index} className="history-item">
            <div className="history-item-image">
              <img src={item.img_url} alt="Album Cover" />
              {index === 0 && <div className="now-playing">Reproduciendo</div>}
            </div>
            <div className="history-item-info">
              <div className="song-title">{item.metadata.split(' - ')[1] || item.metadata}</div>
              <div className="artist-name">{item.metadata.split(' - ')[0]}</div>
              <div className="play-time">{new Date(item.ts).toLocaleTimeString()}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryRadio;
